<template>
  <keep-alive v-if="!!asthmaQuestion">
    <component :is="asthmaQuestion" v-model="modelValue" v-bind="questionData" />
  </keep-alive>
  <div v-else></div>
</template>

<script>
import { Component, ComputedOptions } from 'vue'
import { PropsDefinition, Computed, ModelValueProp } from '@/_typedefs'
import PreviousTreatmentNodeVue from './PreviousTreatment/PreviousTreatmentNode.vue'

/**
 * @typedef {Object} AsthmaNodeProps
 * @property {string} title
 * @property {string} kind
 * @property {object} questionData
 */

/** @typedef {AsthmaNodeProps & ModelValueProp<any>} Props */

export default {
  name: 'AsthmaQuestionNode',
  /** @type {PropsDefinition<Props>} */
  props: {
    value: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    kind: {
      type: String,
      required: true,
    },
    questionData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    /** @type {Computed<Component | null>} */
    asthmaQuestion() {
      const questionMap = {
        'asthma:previous-treatment': PreviousTreatmentNodeVue,
      }

      return questionMap[this.kind] ?? null
    },
    /** @type {ComputedOptions<any>} */
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style></style>
